var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSalesChannel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2-Master",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.0-Master-Option-1",
    transform: "translate(-755.000000, -407.000000)",
    stroke: "#141414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(755.820000, 408.489746)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 6.91034133,
    width: 5.17931733,
    height: 5.17931733,
    rx: 2.58965867
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 14.9401245,
    y: 0,
    width: 5.17931733,
    height: 5.17931733,
    rx: 2.58965867
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 14.9401245,
    y: 13.8206827,
    width: 5.17931733,
    height: 5.17931733,
    rx: 2.58965867
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    points: "14.8766029 2.58965867 10.3733271 2.58965867 10.3733271 16.4103413 14.8766029 16.4103413"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.3733271,
    y1: 9.5,
    x2: 5.24283886,
    y2: 9.5,
    id: "Path-4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSalesChannel);
export default __webpack_public_path__ + "static/media/icon-sales-channel.6d9775c1.svg";
export { ForwardRef as ReactComponent };